import {
  CalendarOutlined,
  CheckSquareOutlined,
  FileTextOutlined,
  HomeOutlined,
  SafetyCertificateOutlined,
  ScheduleOutlined,
  TeamOutlined,
  VideoCameraOutlined,
} from '@ant-design/icons';

import { hideConferenceVendorName } from './conferenceVendorCopy';

/** آیکون‌های بنر ورود — هم‌خوان با منوی پنل */
export const LOGIN_PANEL_ICON_MAP = {
  schedule: ScheduleOutlined,
  team: TeamOutlined,
  calendar: CalendarOutlined,
  home: HomeOutlined,
  'check-square': CheckSquareOutlined,
  'file-text': FileTextOutlined,
  shield: SafetyCertificateOutlined,
  video: VideoCameraOutlined,
};

export function renderLoginPanelIcon(key, className = '') {
  const Icon = LOGIN_PANEL_ICON_MAP[key] ?? ScheduleOutlined;
  return <Icon className={className} />;
}

export const DEFAULT_LOGIN_PANEL = {
  title: 'مدیریت هوشمند جلسات\nدر یک پنل قدرتمند',
  subtitle:
    'با پنل ما همه‌ی جلسات، شرکت‌کنندگان، تقویم و گزارش‌های تیم را در یک نگاه ببینید و مدیریت کنید.',
  highlights: [
    {
      icon: 'schedule',
      title: 'جلسات سازمانی',
      description: 'برنامه‌ریزی، دستور جلسه و ورود آنلاین',
    },
    {
      icon: 'team',
      title: 'اعضا و نقش‌ها',
      description: 'مدیریت شرکت‌کنندگان و دسترسی‌های سازمانی',
    },
    {
      icon: 'calendar',
      title: 'تقویم یکپارچه',
      description: 'نمای زمانی جلسات پیش‌رو و گذشته',
    },
  ],
  stats: [
    { value: '۲۴/۷', label: 'پشتیبانی' },
    { value: '۹۹.۹٪', label: 'در دسترس بودن' },
    { value: '۱۰K+', label: 'کاربر فعال' },
  ],
};

/** ادغام پاسخ API با پیش‌فرض */
export function resolveLoginPanelConfig(apiData) {
  const base = DEFAULT_LOGIN_PANEL;
  if (!apiData || typeof apiData !== 'object') return base;
  const clean = (value) => (typeof value === 'string' ? hideConferenceVendorName(value) : value);
  return {
    title: clean(apiData.title ?? base.title),
    subtitle: clean(apiData.subtitle ?? base.subtitle),
    highlights: (Array.isArray(apiData.highlights) && apiData.highlights.length
      ? apiData.highlights
      : base.highlights
    ).map((item) => ({
      ...item,
      title: clean(item?.title),
      description: clean(item?.description),
    })),
    stats: (Array.isArray(apiData.stats) && apiData.stats.length ? apiData.stats : base.stats).map((stat) => ({
      ...stat,
      value: clean(stat?.value),
      label: clean(stat?.label),
    })),
    use_panel_config: Boolean(apiData.use_panel_config),
    config_source: apiData.config_source ?? 'default',
  };
}

export function splitLoginTitle(title) {
  const text = String(title ?? '').trim() || DEFAULT_LOGIN_PANEL.title;
  const lines = text.split('\n').map((l) => l.trim()).filter(Boolean);
  if (lines.length <= 1) return { line1: lines[0] ?? '', line2: '' };
  return { line1: lines[0], line2: lines.slice(1).join(' ') };
}
